import styled from "styled-components";
import { StaticI18nLink } from "../../Link.js";
import { theme } from "../../../styles/theme.js";
import { device } from "../../../constants.js";

// Estilo base para todos os links de navegação
const baseNavLinkStyles = `
  color: ${theme.colors["neutral-01"]};
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0.7px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  transition: color 100ms ease-in-out;
  text-wrap: nowrap;

  &:hover {
    color: ${theme.colors["vivid-02"]};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors["vivid-02"]};
    outline-offset: 2px;
  }

  @media ${device.tablet} {
    font-size: 12px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }
`;

// Componente para botões (sem href)
export const NavLink = styled.button`
  ${baseNavLinkStyles}
`;

// Componente para links externos (sem StaticI18nLink)
export const NavLinkExternalRaw = styled.a`
  ${baseNavLinkStyles}
`;
